export function createFAQSchema({
  faqs = [],
  pageUrl = "",
  pageName = "",
  description = "",
}) {
  const validFaqs = faqs.filter((faq) => {
    const question = faq.question || faq.q;
    const answer = faq.answer || faq.a;

    return (
      typeof question === "string" &&
      question.trim() !== "" &&
      typeof answer === "string" &&
      answer.trim() !== ""
    );
  });

  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",

    mainEntity: validFaqs.map((faq) => {
      const question = faq.question || faq.q;
      const answer = faq.answer || faq.a;

      const questionSchema = {
        "@type": "Question",
        name: question,
        acceptedAnswer: {
          "@type": "Answer",
          text: answer,
        },
      };

      if (pageUrl && faq.id) {
        questionSchema["@id"] = `${pageUrl}#${faq.id}`;
      }

      return questionSchema;
    }),
  };

  if (pageUrl) {
    schema["@id"] = `${pageUrl}#faq`;
    schema.url = pageUrl;
  }

  if (pageName) {
    schema.name = pageName;
  }

  if (description) {
    schema.description = description;
  }

  return schema;
}